// Money on screen (spec/06 §1, CLAUDE.md): the wire carries integer minor units and an ISO 4217
// code — `{ amount: 15000, currency: 'INR' }` is ₹150.00 — and the console never does arithmetic on
// it, only formats it for display. The minor-unit scale comes from the currency itself (INR and most
// are 2 digits; JPY is 0), read from `Intl`, so a hard-coded ÷100 can never be wrong for a currency.

export interface Money {
  readonly amount: number;
  readonly currency: string;
}

/** Format minor units and a currency as a localised amount, e.g. `₹150.00`. English-only (no i18n). */
export function formatMoney(money: Money): string {
  const formatter = new Intl.NumberFormat('en', { style: 'currency', currency: money.currency });
  const digits = formatter.resolvedOptions().maximumFractionDigits ?? 2;
  return formatter.format(money.amount / 10 ** digits);
}

/** `H:MM` from a whole number of seconds — how time left and durations are shown (spec/05 §4.4). */
export function formatDuration(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours}:${minutes.toString().padStart(2, '0')}`;
}
